import { render } from "./aio-login-snackbar.vue?vue&type=template&id=810ac2b2&scoped=true"
import script from "./aio-login-snackbar.vue?vue&type=script&lang=js"
export * from "./aio-login-snackbar.vue?vue&type=script&lang=js"

import "./aio-login-snackbar.vue?vue&type=style&index=0&id=810ac2b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810ac2b2"]])

export default __exports__